export var PrinterDocSourceType;
(function (PrinterDocSourceType) {
    PrinterDocSourceType["url"] = "url";
})(PrinterDocSourceType || (PrinterDocSourceType = {}));
export var PrintProvider;
(function (PrintProvider) {
    /**
     * The provider type to use if the OS print manager is to handle
     * the print job. Such as AirPrint for iOS
     */
    PrintProvider["system"] = "system";
})(PrintProvider || (PrintProvider = {}));
export var PrintOrientation;
(function (PrintOrientation) {
    PrintOrientation["portrait"] = "portrait";
    PrintOrientation["landscape"] = "landscape";
})(PrintOrientation || (PrintOrientation = {}));
export var PrintErrorType;
(function (PrintErrorType) {
    /**
     * This error is the result of passing in an invalid parameters
     * in a call to the print method.
     * For example, if a non HTTPS URL is passed in for a call that has
     * ‘URL’ as the sourceType.
     */
    PrintErrorType["invalidParameters"] = "invalidParameters";
    /**
     * This error is reserved for unknown errors. An example could be
     * an error that occurs in the usage of the OS Print Manager.
     */
    PrintErrorType["unknownError"] = "unknownError";
})(PrintErrorType || (PrintErrorType = {}));
export var ItemPrintability;
(function (ItemPrintability) {
    /**
     * The supplied item is printable for the given Print Provider.
     */
    ItemPrintability["printable"] = "printable";
    /**
     * The supplied item is not printable for the given Print Provider.
     */
    ItemPrintability["notPrintable"] = "notPrintable";
    /**
     * The Unknown value may be returned, dependent on the ability of
     * printing the item with the specified print provider in the options
     * to the determineItemPrintability method.
     */
    ItemPrintability["unableToDetermine"] = "unableToDetermine";
})(ItemPrintability || (ItemPrintability = {}));
//# sourceMappingURL=printer.js.map